/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deviceAuthActionEnumSchema = z.enum(["login", "register"]).describe("* `login` - Авторизация\n* `register` - Регистрация");
